export const translations = {
  en: {
    // Header
    tryIt: "Try it",
    login: "Login",
    signUp: "Sign Up",
    
    // Hero
    stopFomo: "STOP FOMO. START THINKING.",
    heroTitle: "Don't Follow the",
    heroTitleBold: "Bull Market Hype",
    heroSubtitle: "AI-powered financial advisory that protects you from speculation. Daily insights on crypto, stocks, and market trends.",
    
    // Today's Analysis
    todaysAnalysis: "Today's Analysis",
    updatedDaily: "Updated daily by AI",
    
    // Services
    services: "Services",
    servicesSubtitle: "AI-powered advisory protection tools",
    premium: "PREMIUM",
    
    dailyRecommendations: "Daily Recommendations",
    dailyRecommendationsDesc: "AI analyzes your portfolio and gives personalized advice. GPT-5, Claude, Gemini rotation.",
    
    portfolioProtection: "Portfolio Protection",
    portfolioProtectionDesc: "Real-time alerts on crypto & stocks. Set price targets and get notified instantly.",
    
    aiChat: "AI Chat 24/7",
    aiChatDesc: "Ask anything about markets, strategies, or your portfolio. Instant AI-powered answers.",
    
    // Why section
    whyTitle: "Why DO NOT BULL?",
    whySubtitle: "We're not like other financial advisory platforms",
    
    antiSpeculation: "Anti-Speculation Focus",
    antiSpeculationDesc: "We help you avoid FOMO and make rational decisions based on data, not hype.",
    
    cryptoStocks: "Crypto + Stocks",
    cryptoStocksDesc: "Full support for both crypto and traditional stocks. Diversify intelligently.",
    
    multiAI: "Multi-AI Analysis",
    multiAIDesc: "GPT-5, Claude 4, and Gemini 2.5 Pro work together to give you the best insights.",
    
    portfolioFirst: "Portfolio First",
    portfolioFirstDesc: "Personalized analysis based on YOUR holdings, not generic market news.",
    
    // CTA
    ctaTitle: "Ready to Stop",
    ctaTitleBold: "Speculating",
    ctaSubtitle: "Join clients who think before they act",
    tryItNow: "Try it now",
    
    // Footer
    footerText: "DO NOT BULL © 2025 - Anti-Speculation AI v2.0",
    
    // Auth
    email: "Email",
    password: "Password",
    fullName: "Full Name",
    
    // Dashboard
    welcome: "Welcome",
    yourSummary: "Here's your portfolio summary",
    totalValue: "Total Value",
    profitLoss: "Profit/Loss",
    assets: "Assets",
    performance7Days: "Performance (7 days)",
    latestRecommendation: "Latest Recommendation",
    viewAll: "View all",
    noRecommendation: "No recommendation",
    generateNow: "Generate Now",
    recentAssets: "Recent Assets",
    managePortfolio: "Manage Portfolio",
    noAssets: "No assets in your portfolio",
    addFirstAsset: "Add your first asset",
    dashboard: "Dashboard",
    portfolio: "Portfolio",
    recommendations: "Recommendations",
    pricing: "Pricing",
    logout: "Logout",
    
    // Pricing
    pricingTitle: "Choose Your Plan",
    pricingSubtitle: "Unlock powerful AI advisory tools to protect your assets",
    monthly: "Monthly",
    yearly: "Yearly",
    save20: "Save 20%",
    perMonth: "/month",
    currentPlan: "Current Plan",
    upgradeTo: "Upgrade to",
    
    // Plans
    starterPlan: "Starter",
    starterDesc: "Essential tools to start investing smarter",
    proPlan: "Pro",
    proDesc: "For serious investors",
    premiumPlan: "Premium",
    premiumDesc: "Maximum protection",
    
    // Features
    dailyArticles: "Daily AI articles",
    basicPortfolio: "Basic portfolio tracking",
    priceAlerts: "Price alerts (5 max)",
    emailSupport: "Email support",
    
    aiRecommendations: "AI recommendations (daily)",
    advancedPortfolio: "Advanced portfolio analytics",
    unlimitedAlerts: "Unlimited price alerts",
    multiAIAnalysis: "Multi-AI analysis rotation",
    prioritySupport: "Priority support",
    
    aiChat24: "AI Chat 24/7",
    customStrategies: "Custom advisory strategies",
    portfolioOptimization: "Portfolio optimization",
    riskAnalysis: "Risk analysis & advisory",
    dedicatedSupport: "Dedicated account manager",
    earlyAccess: "Early access to new features",
    
    // Chart Analyzer feature
    chartAnalyzer: "AI Chart Analyzer",
    chartAnalyzerDesc: "Analyze trading charts with AI Vision",
    livePhotoAnalysis: "Live photo analysis from mobile",
    
    // Pricing extras
    notSurePlan: "Not Sure Which Plan?",
    notSurePlanDesc: "Start with Starter for free trial, upgrade anytime as your portfolio grows.",
    savedPerYear: "saved/year",
    popular: "POPULAR",

    // ---- INTERNAL PAGES (post-login) ----
    // Dashboard
    welcomeBack: "Welcome back",
    aiDashboard: "Your AI-powered investing dashboard",
    portfolioValue: "Portfolio Value",
    totalPL: "Total P&L",
    riskLevel: "Risk Level",
    aiHealthScore: "AI Health Score",
    aiMarketSentiment: "AI Market Sentiment",
    updatedByAI: "Updated by AI",
    todaysOpportunities: "Today's Opportunities",
    aiDetectedSignals: "AI-detected signals",
    viewAll: "View all",
    portfolioPerformance: "Portfolio Performance",
    latestAIInsight: "Latest AI Insight",
    allInsights: "All insights",
    noAIInsights: "No AI insights yet",
    generateNowBtn: "Generate Now",
    myPortfolio: "My Portfolio",
    manage: "Manage",
    noAssetsYet: "No assets yet. Start tracking your investments.",
    addFirstAsset: "Add First Asset",
    aiDisclaimer: "AI-generated insights are for educational purposes only. Not financial advice. Always do your own research.",
    medium: "Medium",

    // Gems page
    aiGemDetector: "AI Gem Detector",
    investmentOpportunities: "Investment Opportunities",
    aiDetectedDesc: "AI-detected signals across stocks & crypto",
    totalGems: "Total Gems",
    stocks: "Stocks",
    crypto: "Crypto",
    strongSignals: "Strong Signals",
    sortBy: "Sort:",
    filterBy: "Filter:",
    all: "All",
    lowRisk: "Low Risk",
    strongOnly: "Strong Only",
    scanMarkets: "Scan Markets",
    noGemsDetected: "No gems detected",
    clickRefresh: "Click Refresh to scan the markets",
    scanningMarkets: "Scanning markets...",
    refresh: "Refresh",
    aiAnalysis: "AI Analysis",
    aiMarketAnalysis: "AI Market Analysis",
    bullish: "Bullish",
    neutral: "Neutral",
    bearish: "Bearish",
    timeHorizon: "Time Horizon:",
    whyAIDetected: "Why the AI detected this:",
    gemsDisclaimer: "AI-generated signals for educational purposes only. Not financial advice. Always do your own research before investing.",

    // Portfolio page
    myPortfolioPage: "My Portfolio",
    trackInvestments: "Track and analyze your investments",
    addAsset: "Add Asset",
    totalValue: "Total Value",
    performance: "Performance",
    aiHealth: "AI Health",
    aiPortfolioHealth: "AI Portfolio Health Score",
    personalizedAnalysis: "Personalized analysis of your holdings",
    diversification: "Diversification",
    concentrationRisk: "Concentration Risk",
    assetBalance: "Asset Balance",
    growthScore: "Growth Score",
    assetsCount: "Assets",
    cryptoPct: "Crypto %",
    stocksPct: "Stocks %",
    aiInsights: "AI Insights",
    myAssets: "My Assets",
    buyPrice: "Buy Price",
    current: "Current",
    quantity: "Quantity",
    assetType: "Asset Type",
    symbol: "Symbol",
    name: "Name",
    adding: "Adding...",
    add: "Add",
    portfolioEmpty: "Your portfolio is empty",
    aiHealthDisclaimer: "AI health scores are for educational purposes only. Not financial advice.",

    // Chart Analyzer page
    uploadCapture: "Upload or Capture a Chart",
    uploadDesc: "Get an instant AI-powered technical analysis in seconds",
    uploadFile: "Upload File",
    uploadFileDesc: "Select a chart image from your device",
    takePhoto: "Take Photo",
    takePhotoDesc: "Capture a chart with your camera",
    whatAIAnalyzes: "What the AI will analyze:",
    trendDetection: "Trend Detection",
    trendDetectionDesc: "Bullish / Bearish / Sideways",
    supportResistance: "Support & Resistance",
    supportResistanceDesc: "Key price levels",
    breakoutProbability: "Breakout Probability",
    breakoutDesc: "Entry/exit signals",
    momentum: "Momentum",
    momentumDesc: "RSI, MACD signals",
    patternRecognition: "Pattern Recognition",
    patternDesc: "H&S, triangles, flags",
    riskAssessment: "Risk Assessment",
    riskDesc: "Stop-loss guidance",
    supportedCharts: "Supported:",
    chartFormat: "JPG, PNG, WebP • Max 10MB • AI-powered by GPT-4o Vision",
    analysisResults: "Analysis Results",
    trend: "Trend",
    keyLevels: "Key Levels",
    support: "Support",
    resistance: "Resistance",
    recommendation: "Recommendation",
    detailedAnalysis: "Detailed Analysis",
    analyzing: "Analyzing...",
    analyzeChart: "Analyze Chart",
    analyzeAnother: "Analyze Another Chart",
    chartDisclaimer: "This analysis is for educational purposes only. Do Not Bull does not provide financial advice.",
    premiumRequired: "Chart analysis requires Premium or Platinum subscription",
    
    // Academy section
    academyBadge: "New — Do Not Bull Academy",
    academyTitle: "Learn to invest",
    academyTitleBold: "like a pro",
    academySubtitle: "Structured courses, quizzes, daily lessons and a trading simulator — everything you need to go from beginner to confident investor.",
    academyFeature1Title: "4 Training Modules",
    academyFeature1Desc: "From basics to advanced technical analysis",
    academyFeature2Title: "XP & Level System",
    academyFeature2Desc: "Earn points, level up, unlock badges",
    academyFeature3Title: "Lesson of the Day",
    academyFeature3Desc: "1 micro-lesson per day to keep progressing",
    academyFeature4Title: "Quizzes & Badges",
    academyFeature4Desc: "Test your knowledge and earn rewards",
    academyModule1Label: "Module 1 Curriculum — Free",
    academyModule1Title: "Investment Basics",
    academyProgressLabel: "Progress System",
    academyCTA: "Access the Academy for free",
    academyCTANote: "Module 1 completely free • No credit card",
    
    // Simulator section
    simulatorBadge: "Virtual Trading Simulator",
    simulatorTitle: "Practice without risking",
    simulatorTitleBold: "a single cent",
    simulatorDesc: "Start with ",
    simulatorDescBold: "$10,000 virtual",
    simulatorDescEnd: " and learn to buy/sell stocks and crypto in real time. Perfect for understanding markets before investing real money.",
    simulatorFeature1: "Real-time prices (AAPL, TSLA, NVDA, BTC, ETH...)",
    simulatorFeature2: "Track your gains and losses",
    simulatorFeature3: "Reset in 1 click",
    simulatorFeature4: "Zero real financial risk",
    simulatorCTA: "Try the Simulator",
    simulatorPortfolioTitle: "My Simulated Portfolio",
    simulatorPortfolioNote: "Virtual • 0 risk",
    
    // Legal Pages
    backToHome: "Back to Home",
    lastUpdated: "Last updated:",
    
    // Disclaimer
    legalDisclaimer: "Legal Disclaimer",
    importantDisclaimer: "IMPORTANT DISCLAIMER",
    disclaimerText1: "DoNotBull does not provide financial advice, investment advice, legal advice, or tax advice.",
    disclaimerText2: "All content, information, AI-generated analysis, market insights, forecasts, and data provided on this website are for educational and informational purposes only.",
    disclaimerText3: "Nothing on this website should be interpreted as a recommendation to buy, sell, or hold any financial asset, cryptocurrency, stock, or investment product.",
    disclaimerText4: "You are solely responsible for your own financial decisions and for any profits or losses that may result from those decisions.",
    disclaimerText5: "By using this website, you acknowledge and agree that DoNotBull assumes no responsibility or liability for your investment results.",
    educationalPurpose: "Educational Purpose Only",
    educationalText: "DoNotBull provides AI-powered financial insights and market analysis for educational purposes only. We do not manage funds or provide financial advice.",
    readFullDisclaimer: "Read Full Disclaimer",
    
    // Terms
    termsConditions: "Terms & Conditions",
    termsTitle: "Terms and Conditions – DoNotBull",
    term1: "DoNotBull provides AI-powered market insights and educational financial content only.",
    term2: "DoNotBull is NOT a financial advisor, broker, or asset manager.",
    term3: "Users use the information at their own risk.",
    term4: "All subscriptions are digital services.",
    term5: "Sharing account access is strictly prohibited.",
    term6: "DoNotBull may update, modify or remove content at any time.",
    term7: "By subscribing, you agree to all pages including:",
    termDisclaimer: "Disclaimer",
    termPrivacy: "Privacy Policy",
    termRefund: "Refund Policy",
    termSubscription: "Subscription Policy",
    termResponsibility: "DoNotBull is not responsible for any financial losses, decisions, technical errors, or misuse of information.",
    
    // Privacy Policy
    privacyPolicy: "Privacy Policy",
    privacyTitle: "Privacy Policy – DoNotBull",
    privacyCollect: "We may collect:",
    privacyName: "Name",
    privacyEmail: "Email address",
    privacyPayment: "Payment information (via secure third-party provider)",
    privacyUsage: "Website usage data",
    privacyUse: "We use this data to:",
    privacyAccess: "Provide access to your subscription",
    privacyImprove: "Improve our services",
    privacySendEmails: "Send important account-related emails",
    privacyNoSell: "We do NOT sell your personal data to third parties.",
    privacyRights: "Your rights:",
    privacyExport: "Request export of your data",
    privacyDelete: "Request deletion of your data",
    privacyModify: "Modify your profile",
    privacyContact: "For any request:",
    
    // Refund Policy
    refundPolicy: "Refund Policy",
    refundTitle: "Refund Policy – DoNotBull",
    refundText1: "Due to the nature of digital content and instant access provided at the time of purchase, all sales are final.",
    refundNoRefunds: "No refunds will be issued once the content has been accessed.",
    refundException: "Exception:",
    refundBillingError: "Billing error proven within 72 hours of payment.",
    refundContactText: "For billing inquiries, contact:",
    
    // Subscription Policy
    subscriptionPolicy: "Subscription Policy",
    subscriptionTitle: "Subscription Policy – DoNotBull",
    subscriptionAgree: "By subscribing, you agree that:",
    subscriptionBilled: "Your subscription is billed automatically",
    subscriptionRecurring: "Billing is recurring (monthly / annually)",
    subscriptionCancel: "You can cancel at any time",
    subscriptionNoPartial: "No partial refunds are provided",
    subscriptionActive: "Access remains active until the end of the billing period",
    subscriptionCancelHow: "To cancel:",
    subscriptionCancelText: "Use your dashboard or contact support at",
    
    // Cookie Policy
    cookiePolicy: "Cookie Policy",
    cookieTitle: "Cookie Policy – DoNotBull",
    cookieUse: "We use cookies to:",
    cookieKeepLogged: "Keep users logged in",
    cookiePerformance: "Improve site performance",
    cookieAnalyze: "Analyze traffic",
    cookieAccept: "By using this website, you accept our use of cookies.",
    cookieDisable: "You may disable cookies in your browser settings.",
    
    // Contact
    contactUs: "Contact Us",
    contactTitle: "Contact – DoNotBull",
    contactSupport: "Support Email:",
    contactGeneral: "General Inquiries:",
    contactWebsite: "Website:",
    contactCompanyInfo: "DoNotBull is an independent educational platform providing financial insights powered by AI.",
    contactCompanyDetails: "(Company details to be added upon incorporation.)",
    contactResponse: "We typically respond within 24-48 hours.",
    
    // Footer Legal
    footerLegal: "Legal",
    footerPolicies: "Policies",
    footerContact: "Contact",
    footerCompanyInfo: "AI-powered financial insights for educational purposes.",
    footerCopyright: "DoNotBull. All rights reserved.",
    footerDisclaimer: "We do NOT provide investment services. We do NOT manage funds. We do NOT offer brokerage services.",
  },
  
  fr: {
    // Header
    tryIt: "Essayer",
    login: "Connexion",
    signUp: "Inscription",
    
    // Hero
    stopFomo: "STOP FOMO. COMMENCEZ À RÉFLÉCHIR.",
    heroTitle: "Ne Suivez Pas le",
    heroTitleBold: "Bull Market Hype",
    heroSubtitle: "Conseils financiers alimentés par l'IA qui vous protègent de la spéculation. Insights quotidiens sur crypto, actions et tendances du marché.",
    
    // Today's Analysis
    todaysAnalysis: "Analyse du Jour",
    updatedDaily: "Mis à jour quotidiennement par l'IA",
    
    // Services
    services: "Services",
    servicesSubtitle: "Outils de conseil et protection alimentés par l'IA",
    premium: "PREMIUM",
    
    dailyRecommendations: "Recommandations Quotidiennes",
    dailyRecommendationsDesc: "L'IA analyse votre portfolio et donne des conseils personnalisés. Rotation GPT-5, Claude, Gemini.",
    
    portfolioProtection: "Protection du Portfolio",
    portfolioProtectionDesc: "Alertes en temps réel sur crypto & actions. Définissez des objectifs de prix et soyez notifié instantanément.",
    
    aiChat: "Chat IA 24/7",
    aiChatDesc: "Posez n'importe quelle question sur les marchés, stratégies ou votre portfolio. Réponses instantanées par IA.",
    
    // Why section
    whyTitle: "Pourquoi DO NOT BULL?",
    whySubtitle: "Nous ne sommes pas comme les autres plateformes de conseil financier",
    
    antiSpeculation: "Focus Anti-Spéculation",
    antiSpeculationDesc: "Nous vous aidons à éviter le FOMO et à prendre des décisions rationnelles basées sur les données, pas le hype.",
    
    cryptoStocks: "Crypto + Actions",
    cryptoStocksDesc: "Support complet pour crypto et actions traditionnelles. Diversifiez intelligemment.",
    
    multiAI: "Analyse Multi-IA",
    multiAIDesc: "GPT-5, Claude 4 et Gemini 2.5 Pro travaillent ensemble pour vous donner les meilleurs insights.",
    
    portfolioFirst: "Portfolio en Premier",
    portfolioFirstDesc: "Analyse personnalisée basée sur VOS avoirs, pas sur des actualités génériques.",
    
    // CTA
    ctaTitle: "Prêt à Arrêter de",
    ctaTitleBold: "Spéculer",
    ctaSubtitle: "Rejoignez les clients qui réfléchissent avant d'agir",
    tryItNow: "Essayer maintenant",
    
    // Footer
    footerText: "DO NOT BULL © 2025 - IA Anti-Spéculation v2.0",
    
    // Auth
    email: "Email",
    password: "Mot de passe",
    fullName: "Nom complet",
    
    // Dashboard
    welcome: "Bienvenue",
    yourSummary: "Voici votre résumé de portfolio",
    totalValue: "Valeur Totale",
    profitLoss: "Profit/Perte",
    assets: "Actifs",
    performance7Days: "Performance (7 jours)",
    latestRecommendation: "Dernière Recommandation",
    viewAll: "Voir tout",
    noRecommendation: "Aucune recommandation",
    generateNow: "Générer Maintenant",
    recentAssets: "Actifs Récents",
    managePortfolio: "Gérer Portfolio",
    noAssets: "Aucun actif dans votre portfolio",
    addFirstAsset: "Ajouter votre premier actif",
    dashboard: "Tableau de bord",
    portfolio: "Portfolio",
    recommendations: "Recommandations",
    pricing: "Tarifs",
    logout: "Déconnexion",
    
    // Pricing
    pricingTitle: "Choisissez Votre Plan",
    pricingSubtitle: "Débloquez des outils IA puissants pour protéger vos actifs",
    monthly: "Mensuel",
    yearly: "Annuel",
    save20: "Économisez 20%",
    perMonth: "/mois",
    currentPlan: "Plan Actuel",
    upgradeTo: "Passer à",
    
    // Plans
    starterPlan: "Débutant",
    starterDesc: "Les outils essentiels pour commencer à investir",
    proPlan: "Pro",
    proDesc: "Pour investisseurs sérieux",
    premiumPlan: "Premium",
    premiumDesc: "Protection maximale",
    
    // Features
    dailyArticles: "Articles IA quotidiens",
    basicPortfolio: "Suivi portfolio basique",
    priceAlerts: "Alertes prix (5 max)",
    emailSupport: "Support email",
    
    aiRecommendations: "Recommandations IA (quotidiennes)",
    advancedPortfolio: "Analytiques portfolio avancées",
    unlimitedAlerts: "Alertes prix illimitées",
    multiAIAnalysis: "Rotation analyse multi-IA",
    prioritySupport: "Support prioritaire",
    
    aiChat24: "Chat IA 24/7",
    customStrategies: "Stratégies de conseil personnalisées",
    portfolioOptimization: "Optimisation du portfolio",
    riskAnalysis: "Analyse de risque & couverture",
    dedicatedSupport: "Gestionnaire de compte dédié",
    earlyAccess: "Accès anticipé aux nouvelles fonctionnalités",
    
    // Chart Analyzer feature
    chartAnalyzer: "Analyseur de Graphiques IA",
    chartAnalyzerDesc: "Analysez des graphiques de trading avec l'IA Vision",
    livePhotoAnalysis: "Analyse photo en direct depuis mobile",
    
    // Tarifs extras
    notSurePlan: "Pas Sûr du Plan ?",
    notSurePlanDesc: "Commencez avec le plan Starter pour un essai gratuit, montez en gamme à tout moment selon votre portfolio.",
    savedPerYear: "économisés/an",
    popular: "POPULAIRE",

    // ---- PAGES INTERNES (post-connexion) ----
    // Dashboard
    welcomeBack: "Bienvenue",
    aiDashboard: "Votre tableau de bord d'investissement IA",
    portfolioValue: "Valeur Portfolio",
    totalPL: "P&L Total",
    riskLevel: "Niveau de Risque",
    aiHealthScore: "Score Santé IA",
    aiMarketSentiment: "Sentiment Marché IA",
    updatedByAI: "Mis à jour par IA",
    todaysOpportunities: "Opportunités du Jour",
    aiDetectedSignals: "Signaux détectés par IA",
    viewAll: "Voir tout",
    portfolioPerformance: "Performance Portfolio",
    latestAIInsight: "Dernière Analyse IA",
    allInsights: "Toutes les analyses →",
    noAIInsights: "Aucune analyse IA pour l'instant",
    generateNowBtn: "Générer Maintenant",
    myPortfolio: "Mon Portfolio",
    manage: "Gérer",
    noAssetsYet: "Aucun actif. Commencez à suivre vos investissements.",
    addFirstAsset: "Ajouter un Actif",
    aiDisclaimer: "Les analyses IA sont à titre éducatif uniquement. Pas de conseil financier. Faites toujours vos propres recherches.",
    medium: "Modéré",

    // Page Pépites
    aiGemDetector: "Détecteur de Pépites IA",
    investmentOpportunities: "Opportunités d'Investissement",
    aiDetectedDesc: "Signaux détectés par IA sur actions & crypto",
    totalGems: "Total Pépites",
    stocks: "Actions",
    crypto: "Crypto",
    strongSignals: "Signaux Forts",
    sortBy: "Trier :",
    filterBy: "Filtrer :",
    all: "Tout",
    lowRisk: "Faible Risque",
    strongOnly: "Forts Seulement",
    scanMarkets: "Scanner",
    noGemsDetected: "Aucune pépite détectée",
    clickRefresh: "Cliquez sur Actualiser pour scanner les marchés",
    scanningMarkets: "Analyse des marchés...",
    refresh: "Actualiser",
    aiAnalysis: "Analyse IA",
    aiMarketAnalysis: "Analyse Marché IA",
    bullish: "Haussier",
    neutral: "Neutre",
    bearish: "Baissier",
    timeHorizon: "Horizon :",
    whyAIDetected: "Pourquoi l'IA l'a détecté :",
    gemsDisclaimer: "Signaux générés par IA à titre éducatif. Pas de conseil financier. Faites toujours vos propres recherches.",

    // Page Portfolio
    myPortfolioPage: "Mon Portfolio",
    trackInvestments: "Suivez et analysez vos investissements",
    addAsset: "Ajouter un Actif",
    totalValue: "Valeur Totale",
    performance: "Performance",
    aiHealth: "Santé IA",
    aiPortfolioHealth: "Score de Santé Portfolio IA",
    personalizedAnalysis: "Analyse personnalisée de vos positions",
    diversification: "Diversification",
    concentrationRisk: "Risque de Concentration",
    assetBalance: "Équilibre des Actifs",
    growthScore: "Score de Croissance",
    assetsCount: "Actifs",
    cryptoPct: "Crypto %",
    stocksPct: "Actions %",
    aiInsights: "Analyses IA",
    myAssets: "Mes Actifs",
    buyPrice: "Prix d'Achat",
    current: "Actuel",
    quantity: "Quantité",
    assetType: "Type d'Actif",
    symbol: "Symbole",
    name: "Nom",
    adding: "Ajout...",
    add: "Ajouter",
    portfolioEmpty: "Votre portfolio est vide",
    aiHealthDisclaimer: "Les scores de santé IA sont à titre éducatif uniquement. Pas de conseil financier.",

    // Page Chart Analyzer
    uploadCapture: "Uploadez ou Capturez un Graphique",
    uploadDesc: "Obtenez une analyse technique IA instantanée en quelques secondes",
    uploadFile: "Uploader un Fichier",
    uploadFileDesc: "Sélectionnez un graphique depuis votre appareil",
    takePhoto: "Prendre une Photo",
    takePhotoDesc: "Capturez un graphique avec votre caméra",
    whatAIAnalyzes: "Ce que l'IA va analyser :",
    trendDetection: "Détection de Tendance",
    trendDetectionDesc: "Haussier / Baissier / Latéral",
    supportResistance: "Support & Résistance",
    supportResistanceDesc: "Niveaux de prix clés",
    breakoutProbability: "Probabilité de Cassure",
    breakoutDesc: "Signaux d'entrée/sortie",
    momentum: "Momentum",
    momentumDesc: "Signaux RSI, MACD",
    patternRecognition: "Reconnaissance de Patterns",
    patternDesc: "Tête-épaules, triangles, drapeaux",
    riskAssessment: "Évaluation des Risques",
    riskDesc: "Guidage stop-loss",
    supportedCharts: "Supportés :",
    chartFormat: "JPG, PNG, WebP • Max 10MB • IA propulsée par GPT-4o Vision",
    analysisResults: "Résultats de l'Analyse",
    trend: "Tendance",
    keyLevels: "Niveaux Clés",
    support: "Support",
    resistance: "Résistance",
    recommendation: "Recommandation",
    detailedAnalysis: "Analyse Détaillée",
    analyzing: "Analyse en cours...",
    analyzeChart: "Analyser le Graphique",
    analyzeAnother: "Analyser un Autre Graphique",
    chartDisclaimer: "Cette analyse est à des fins éducatives uniquement. Do Not Bull ne fournit pas de conseils financiers.",
    premiumRequired: "L'analyse de graphiques nécessite un abonnement Premium ou Platinum",
    
    // Section Académie
    academyBadge: "Nouveau — Académie Do Not Bull",
    academyTitle: "Apprends à investir",
    academyTitleBold: "comme un pro",
    academySubtitle: "Des cours structurés, des quiz, des leçons quotidiennes et un simulateur de trading — tout ce qu'il faut pour passer de débutant à investisseur confiant.",
    academyFeature1Title: "4 Modules de formation",
    academyFeature1Desc: "Des bases jusqu'à l'analyse technique avancée",
    academyFeature2Title: "Système XP & Niveaux",
    academyFeature2Desc: "Gagne des points, monte en niveau, débloque des badges",
    academyFeature3Title: "Leçon du Jour",
    academyFeature3Desc: "1 micro-leçon par jour pour progresser en continu",
    academyFeature4Title: "Quiz & Badges",
    academyFeature4Desc: "Valide tes connaissances et décroche des récompenses",
    academyModule1Label: "Programme Module 1 — Gratuit",
    academyModule1Title: "Les Bases de l'Investissement",
    academyProgressLabel: "Système de progression",
    academyCTA: "Accéder à l'Académie gratuitement",
    academyCTANote: "Module 1 entièrement gratuit • Pas de carte bancaire",
    
    // Section Simulateur
    simulatorBadge: "Simulateur de Trading Virtuel",
    simulatorTitle: "Entraîne-toi sans risquer",
    simulatorTitleBold: "un seul centime",
    simulatorDesc: "Démarre avec ",
    simulatorDescBold: "10 000 $ virtuels",
    simulatorDescEnd: " et apprends à acheter/vendre des actions et cryptos en temps réel. Parfait pour comprendre les marchés avant d'investir ton vrai argent.",
    simulatorFeature1: "Prix en temps réel (AAPL, TSLA, NVDA, BTC, ETH...)",
    simulatorFeature2: "Suivi de tes gains et pertes",
    simulatorFeature3: "Réinitialisation en 1 clic",
    simulatorFeature4: "Aucun risque financier réel",
    simulatorCTA: "Essayer le Simulateur",
    simulatorPortfolioTitle: "Mon Portefeuille Simulé",
    simulatorPortfolioNote: "Virtuel • 0 risque",
    
    // Pages Légales
    backToHome: "Retour à l'accueil",
    lastUpdated: "Dernière mise à jour :",
    
    // Disclaimer
    legalDisclaimer: "Avertissement Légal",
    importantDisclaimer: "AVERTISSEMENT IMPORTANT",
    disclaimerText1: "DoNotBull ne fournit pas de conseils financiers, de conseils d'investissement, de conseils juridiques ou de conseils fiscaux.",
    disclaimerText2: "Tout le contenu, les informations, les analyses générées par l'IA, les perspectives du marché, les prévisions et les données fournies sur ce site web sont uniquement à des fins éducatives et informatives.",
    disclaimerText3: "Rien sur ce site web ne doit être interprété comme une recommandation d'achat, de vente ou de conservation d'un actif financier, d'une cryptomonnaie, d'une action ou d'un produit d'investissement.",
    disclaimerText4: "Vous êtes seul responsable de vos propres décisions financières et de tout profit ou perte qui pourrait en résulter.",
    disclaimerText5: "En utilisant ce site web, vous reconnaissez et acceptez que DoNotBull n'assume aucune responsabilité pour vos résultats d'investissement.",
    educationalPurpose: "But Éducatif Uniquement",
    educationalText: "DoNotBull fournit des perspectives financières alimentées par l'IA et des analyses de marché à des fins éducatives uniquement. Nous ne gérons pas de fonds et ne fournissons pas de conseils financiers.",
    readFullDisclaimer: "Lire l'Avertissement Complet",
    
    // Conditions
    termsConditions: "Conditions Générales",
    termsTitle: "Conditions Générales – DoNotBull",
    term1: "DoNotBull fournit des perspectives de marché alimentées par l'IA et du contenu financier éducatif uniquement.",
    term2: "DoNotBull n'est PAS un conseiller financier, courtier ou gestionnaire d'actifs.",
    term3: "Les utilisateurs utilisent les informations à leurs propres risques.",
    term4: "Tous les abonnements sont des services numériques.",
    term5: "Le partage de l'accès au compte est strictement interdit.",
    term6: "DoNotBull peut mettre à jour, modifier ou supprimer du contenu à tout moment.",
    term7: "En vous abonnant, vous acceptez toutes les pages, y compris :",
    termDisclaimer: "Avertissement",
    termPrivacy: "Politique de Confidentialité",
    termRefund: "Politique de Remboursement",
    termSubscription: "Politique d'Abonnement",
    termResponsibility: "DoNotBull n'est pas responsable des pertes financières, décisions, erreurs techniques ou mauvaise utilisation des informations.",
    
    // Politique de Confidentialité
    privacyPolicy: "Politique de Confidentialité",
    privacyTitle: "Politique de Confidentialité – DoNotBull",
    privacyCollect: "Nous pouvons collecter :",
    privacyName: "Nom",
    privacyEmail: "Adresse email",
    privacyPayment: "Informations de paiement (via un fournisseur tiers sécurisé)",
    privacyUsage: "Données d'utilisation du site web",
    privacyUse: "Nous utilisons ces données pour :",
    privacyAccess: "Fournir l'accès à votre abonnement",
    privacyImprove: "Améliorer nos services",
    privacySendEmails: "Envoyer des emails importants liés au compte",
    privacyNoSell: "Nous ne vendons PAS vos données personnelles à des tiers.",
    privacyRights: "Vos droits :",
    privacyExport: "Demander l'exportation de vos données",
    privacyDelete: "Demander la suppression de vos données",
    privacyModify: "Modifier votre profil",
    privacyContact: "Pour toute demande :",
    
    // Politique de Remboursement
    refundPolicy: "Politique de Remboursement",
    refundTitle: "Politique de Remboursement – DoNotBull",
    refundText1: "En raison de la nature du contenu numérique et de l'accès instantané fourni au moment de l'achat, toutes les ventes sont définitives.",
    refundNoRefunds: "Aucun remboursement ne sera émis une fois que le contenu a été consulté.",
    refundException: "Exception :",
    refundBillingError: "Erreur de facturation prouvée dans les 72 heures suivant le paiement.",
    refundContactText: "Pour les demandes de facturation, contactez :",
    
    // Politique d'Abonnement
    subscriptionPolicy: "Politique d'Abonnement",
    subscriptionTitle: "Politique d'Abonnement – DoNotBull",
    subscriptionAgree: "En vous abonnant, vous acceptez que :",
    subscriptionBilled: "Votre abonnement est facturé automatiquement",
    subscriptionRecurring: "La facturation est récurrente (mensuelle / annuelle)",
    subscriptionCancel: "Vous pouvez annuler à tout moment",
    subscriptionNoPartial: "Aucun remboursement partiel n'est fourni",
    subscriptionActive: "L'accès reste actif jusqu'à la fin de la période de facturation",
    subscriptionCancelHow: "Pour annuler :",
    subscriptionCancelText: "Utilisez votre tableau de bord ou contactez le support à",
    
    // Politique de Cookies
    cookiePolicy: "Politique de Cookies",
    cookieTitle: "Politique de Cookies – DoNotBull",
    cookieUse: "Nous utilisons des cookies pour :",
    cookieKeepLogged: "Garder les utilisateurs connectés",
    cookiePerformance: "Améliorer les performances du site",
    cookieAnalyze: "Analyser le trafic",
    cookieAccept: "En utilisant ce site web, vous acceptez notre utilisation des cookies.",
    cookieDisable: "Vous pouvez désactiver les cookies dans les paramètres de votre navigateur.",
    
    // Contact
    contactUs: "Nous Contacter",
    contactTitle: "Contact – DoNotBull",
    contactSupport: "Email de Support :",
    contactGeneral: "Demandes Générales :",
    contactWebsite: "Site Web :",
    contactCompanyInfo: "DoNotBull est une plateforme éducative indépendante fournissant des perspectives financières alimentées par l'IA.",
    contactCompanyDetails: "(Détails de l'entreprise à ajouter lors de l'incorporation.)",
    contactResponse: "Nous répondons généralement dans les 24-48 heures.",
    
    // Footer Légal
    footerLegal: "Légal",
    footerPolicies: "Politiques",
    footerContact: "Contact",
    footerCompanyInfo: "Perspectives financières alimentées par l'IA à des fins éducatives.",
    footerCopyright: "DoNotBull. Tous droits réservés.",
    footerDisclaimer: "Nous ne fournissons PAS de services d'investissement. Nous ne gérons PAS de fonds. Nous n'offrons PAS de services de courtage.",
  },
  
  es: {
    // Header
    tryIt: "Probar",
    login: "Iniciar sesión",
    signUp: "Registrarse",
    
    // Hero
    stopFomo: "DETÉN EL FOMO. EMPIEZA A PENSAR.",
    heroTitle: "No Sigas el",
    heroTitleBold: "Hype del Bull Market",
    heroSubtitle: "Asesoramiento financiero impulsado por IA que te protege de la especulación. Insights diarios sobre crypto, acciones y tendencias del mercado.",
    
    // Today's Analysis
    todaysAnalysis: "Análisis de Hoy",
    updatedDaily: "Actualizado diariamente por IA",
    
    // Services
    services: "Servicios",
    servicesSubtitle: "Herramientas de asesoramiento y protección impulsadas por IA",
    premium: "PREMIUM",
    
    dailyRecommendations: "Recomendaciones Diarias",
    dailyRecommendationsDesc: "La IA analiza tu portfolio y da consejos personalizados. Rotación GPT-5, Claude, Gemini.",
    
    portfolioProtection: "Protección del Portfolio",
    portfolioProtectionDesc: "Alertas en tiempo real sobre crypto y acciones. Establece objetivos de precio y recibe notificaciones al instante.",
    
    aiChat: "Chat IA 24/7",
    aiChatDesc: "Pregunta lo que quieras sobre mercados, estrategias o tu portfolio. Respuestas instantáneas por IA.",
    
    // Why section
    whyTitle: "¿Por Qué DO NOT BULL?",
    whySubtitle: "No somos como otras plataformas de asesoramiento financiero",
    
    antiSpeculation: "Enfoque Anti-Especulación",
    antiSpeculationDesc: "Te ayudamos a evitar el FOMO y tomar decisiones racionales basadas en datos, no en hype.",
    
    cryptoStocks: "Crypto + Acciones",
    cryptoStocksDesc: "Soporte completo para crypto y acciones tradicionales. Diversifica inteligentemente.",
    
    multiAI: "Análisis Multi-IA",
    multiAIDesc: "GPT-5, Claude 4 y Gemini 2.5 Pro trabajan juntos para darte los mejores insights.",
    
    portfolioFirst: "Portfolio Primero",
    portfolioFirstDesc: "Análisis personalizado basado en TUS tenencias, no noticias genéricas del mercado.",
    
    // CTA
    ctaTitle: "¿Listo para Dejar de",
    ctaTitleBold: "Especular",
    ctaSubtitle: "Únete a clientes que piensan antes de actuar",
    tryItNow: "Probar ahora",
    
    // Footer
    footerText: "DO NOT BULL © 2025 - IA Anti-Especulación v2.0",
    
    // Auth
    email: "Email",
    password: "Contraseña",
    fullName: "Nombre completo",
    
    // Dashboard
    welcome: "Bienvenido",
    yourSummary: "Aquí está tu resumen de portfolio",
    totalValue: "Valor Total",
    profitLoss: "Ganancia/Pérdida",
    assets: "Activos",
    performance7Days: "Rendimiento (7 días)",
    latestRecommendation: "Última Recomendación",
    viewAll: "Ver todo",
    noRecommendation: "Sin recomendación",
    generateNow: "Generar Ahora",
    recentAssets: "Activos Recientes",
    managePortfolio: "Gestionar Portfolio",
    noAssets: "Sin activos en tu portfolio",
    addFirstAsset: "Añade tu primer activo",
    dashboard: "Panel",
    portfolio: "Portfolio",
    recommendations: "Recomendaciones",
    pricing: "Precios",
    logout: "Cerrar sesión",
    
    // Pricing
    pricingTitle: "Elige Tu Plan",
    pricingSubtitle: "Desbloquea herramientas IA potentes para proteger tus activos",
    monthly: "Mensual",
    yearly: "Anual",
    save20: "Ahorra 20%",
    perMonth: "/mes",
    currentPlan: "Plan Actual",
    upgradeTo: "Actualizar a",
    
    // Plans
    starterPlan: "Iniciador",
    starterDesc: "Las herramientas esenciales para empezar a invertir",
    proPlan: "Pro",
    proDesc: "Para inversores serios",
    premiumPlan: "Premium",
    premiumDesc: "Máxima protección",
    
    // Features
    dailyArticles: "Artículos IA diarios",
    basicPortfolio: "Seguimiento básico del portfolio",
    priceAlerts: "Alertas de precio (5 máx)",
    emailSupport: "Soporte por email",
    
    aiRecommendations: "Recomendaciones IA (diarias)",
    advancedPortfolio: "Analíticas avanzadas del portfolio",
    unlimitedAlerts: "Alertas de precio ilimitadas",
    multiAIAnalysis: "Rotación de análisis multi-IA",
    prioritySupport: "Soporte prioritario",
    
    aiChat24: "Chat IA 24/7",
    customStrategies: "Estrategias de asesoramiento personalizadas",
    portfolioOptimization: "Optimización del portfolio",
    riskAnalysis: "Análisis de riesgo y cobertura",
    dedicatedSupport: "Gestor de cuenta dedicado",
    earlyAccess: "Acceso anticipado a nuevas funciones",
    
    // Chart Analyzer feature
    chartAnalyzer: "Analizador de Gráficos IA",
    chartAnalyzerDesc: "Analiza gráficos de trading con IA Vision",
    livePhotoAnalysis: "Análisis de foto en vivo desde móvil",
    
    // Precios extras
    notSurePlan: "¿No Estás Seguro del Plan?",
    notSurePlanDesc: "Empieza con Starter para la prueba gratuita, actualiza en cualquier momento a medida que tu portfolio crece.",
    savedPerYear: "ahorrados/año",
    popular: "POPULAR",

    // ---- PÁGINAS INTERNAS (post-login) ----
    // Dashboard
    welcomeBack: "Bienvenido de nuevo",
    aiDashboard: "Tu panel de inversión con IA",
    portfolioValue: "Valor Cartera",
    totalPL: "P&L Total",
    riskLevel: "Nivel de Riesgo",
    aiHealthScore: "Puntuación Salud IA",
    aiMarketSentiment: "Sentimiento Mercado IA",
    updatedByAI: "Actualizado por IA",
    todaysOpportunities: "Oportunidades de Hoy",
    aiDetectedSignals: "Señales detectadas por IA",
    viewAll: "Ver todo",
    portfolioPerformance: "Rendimiento Cartera",
    latestAIInsight: "Último Análisis IA",
    allInsights: "Todos los análisis →",
    noAIInsights: "Aún no hay análisis IA",
    generateNowBtn: "Generar Ahora",
    myPortfolio: "Mi Cartera",
    manage: "Gestionar",
    noAssetsYet: "Sin activos. Empieza a seguir tus inversiones.",
    addFirstAsset: "Añadir Primer Activo",
    aiDisclaimer: "Los análisis de IA son solo para fines educativos. No son consejos financieros.",
    medium: "Medio",

    // Página Gemas
    aiGemDetector: "Detector de Gemas IA",
    investmentOpportunities: "Oportunidades de Inversión",
    aiDetectedDesc: "Señales detectadas por IA en acciones y cripto",
    totalGems: "Total Gemas",
    stocks: "Acciones",
    crypto: "Cripto",
    strongSignals: "Señales Fuertes",
    sortBy: "Ordenar:",
    filterBy: "Filtrar:",
    all: "Todas",
    lowRisk: "Bajo Riesgo",
    strongOnly: "Solo Fuertes",
    scanMarkets: "Escanear",
    noGemsDetected: "No se detectaron gemas",
    clickRefresh: "Haz clic en Actualizar para escanear los mercados",
    scanningMarkets: "Analizando mercados...",
    refresh: "Actualizar",
    aiAnalysis: "Análisis IA",
    aiMarketAnalysis: "Análisis de Mercado IA",
    bullish: "Alcista",
    neutral: "Neutral",
    bearish: "Bajista",
    timeHorizon: "Horizonte:",
    whyAIDetected: "Por qué la IA lo detectó:",
    gemsDisclaimer: "Señales generadas por IA solo con fines educativos. No son consejos financieros.",

    // Página Cartera
    myPortfolioPage: "Mi Cartera",
    trackInvestments: "Sigue y analiza tus inversiones",
    addAsset: "Añadir Activo",
    totalValue: "Valor Total",
    performance: "Rendimiento",
    aiHealth: "Salud IA",
    aiPortfolioHealth: "Puntuación de Salud de Cartera IA",
    personalizedAnalysis: "Análisis personalizado de tus posiciones",
    diversification: "Diversificación",
    concentrationRisk: "Riesgo de Concentración",
    assetBalance: "Equilibrio de Activos",
    growthScore: "Puntuación de Crecimiento",
    assetsCount: "Activos",
    cryptoPct: "Cripto %",
    stocksPct: "Acciones %",
    aiInsights: "Análisis IA",
    myAssets: "Mis Activos",
    buyPrice: "Precio Compra",
    current: "Actual",
    quantity: "Cantidad",
    assetType: "Tipo de Activo",
    symbol: "Símbolo",
    name: "Nombre",
    adding: "Añadiendo...",
    add: "Añadir",
    portfolioEmpty: "Tu cartera está vacía",
    aiHealthDisclaimer: "Las puntuaciones de salud IA son solo para fines educativos. No son consejos financieros.",

    // Página Analizador de Gráficos
    uploadCapture: "Subir o Capturar un Gráfico",
    uploadDesc: "Obtén un análisis técnico IA instantáneo en segundos",
    uploadFile: "Subir Archivo",
    uploadFileDesc: "Selecciona un gráfico desde tu dispositivo",
    takePhoto: "Tomar Foto",
    takePhotoDesc: "Captura un gráfico con tu cámara",
    whatAIAnalyzes: "Lo que la IA analizará:",
    trendDetection: "Detección de Tendencia",
    trendDetectionDesc: "Alcista / Bajista / Lateral",
    supportResistance: "Soporte y Resistencia",
    supportResistanceDesc: "Niveles de precio clave",
    breakoutProbability: "Probabilidad de Ruptura",
    breakoutDesc: "Señales de entrada/salida",
    momentum: "Momentum",
    momentumDesc: "Señales RSI, MACD",
    patternRecognition: "Reconocimiento de Patrones",
    patternDesc: "H&S, triángulos, banderas",
    riskAssessment: "Evaluación de Riesgo",
    riskDesc: "Orientación stop-loss",
    supportedCharts: "Soportados:",
    chartFormat: "JPG, PNG, WebP • Máx 10MB • IA con GPT-4o Vision",
    analysisResults: "Resultados del Análisis",
    trend: "Tendencia",
    keyLevels: "Niveles Clave",
    support: "Soporte",
    resistance: "Resistencia",
    recommendation: "Recomendación",
    detailedAnalysis: "Análisis Detallado",
    analyzing: "Analizando...",
    analyzeChart: "Analizar Gráfico",
    analyzeAnother: "Analizar Otro Gráfico",
    chartDisclaimer: "Este análisis es solo para fines educativos. Do Not Bull no proporciona asesoramiento financiero.",
    premiumRequired: "El análisis de gráficos requiere suscripción Premium o Platinum",
    
    // Sección Academia
    academyBadge: "Nuevo — Academia Do Not Bull",
    academyTitle: "Aprende a invertir",
    academyTitleBold: "como un profesional",
    academySubtitle: "Cursos estructurados, cuestionarios, lecciones diarias y un simulador de trading — todo lo necesario para pasar de principiante a inversor confiado.",
    academyFeature1Title: "4 Módulos de formación",
    academyFeature1Desc: "Desde lo básico hasta el análisis técnico avanzado",
    academyFeature2Title: "Sistema XP y Niveles",
    academyFeature2Desc: "Gana puntos, sube de nivel, desbloquea insignias",
    academyFeature3Title: "Lección del Día",
    academyFeature3Desc: "1 microlección al día para progresar continuamente",
    academyFeature4Title: "Cuestionarios e Insignias",
    academyFeature4Desc: "Valida tus conocimientos y consigue recompensas",
    academyModule1Label: "Programa Módulo 1 — Gratis",
    academyModule1Title: "Fundamentos de la Inversión",
    academyProgressLabel: "Sistema de progresión",
    academyCTA: "Acceder a la Academia gratis",
    academyCTANote: "Módulo 1 completamente gratis • Sin tarjeta de crédito",
    
    // Sección Simulador
    simulatorBadge: "Simulador de Trading Virtual",
    simulatorTitle: "Practica sin arriesgar",
    simulatorTitleBold: "ni un centavo",
    simulatorDesc: "Empieza con ",
    simulatorDescBold: "$10,000 virtuales",
    simulatorDescEnd: " y aprende a comprar/vender acciones y criptos en tiempo real. Perfecto para entender los mercados antes de invertir dinero real.",
    simulatorFeature1: "Precios en tiempo real (AAPL, TSLA, NVDA, BTC, ETH...)",
    simulatorFeature2: "Seguimiento de ganancias y pérdidas",
    simulatorFeature3: "Reinicio en 1 clic",
    simulatorFeature4: "Cero riesgo financiero real",
    simulatorCTA: "Probar el Simulador",
    simulatorPortfolioTitle: "Mi Cartera Simulada",
    simulatorPortfolioNote: "Virtual • 0 riesgo",
    
    // Páginas Legales
    backToHome: "Volver al Inicio",
    lastUpdated: "Última actualización:",
    
    // Descargo
    legalDisclaimer: "Descargo Legal",
    importantDisclaimer: "DESCARGO IMPORTANTE",
    disclaimerText1: "DoNotBull no proporciona asesoramiento financiero, asesoramiento de inversiones, asesoramiento legal o asesoramiento fiscal.",
    disclaimerText2: "Todo el contenido, información, análisis generados por IA, perspectivas del mercado, pronósticos y datos proporcionados en este sitio web son solo con fines educativos e informativos.",
    disclaimerText3: "Nada en este sitio web debe interpretarse como una recomendación para comprar, vender o mantener cualquier activo financiero, criptomoneda, acción o producto de inversión.",
    disclaimerText4: "Usted es el único responsable de sus propias decisiones financieras y de las ganancias o pérdidas que puedan resultar de esas decisiones.",
    disclaimerText5: "Al usar este sitio web, usted reconoce y acepta que DoNotBull no asume ninguna responsabilidad por sus resultados de inversión.",
    educationalPurpose: "Solo con Fines Educativos",
    educationalText: "DoNotBull proporciona perspectivas financieras impulsadas por IA y análisis de mercado solo con fines educativos. No gestionamos fondos ni proporcionamos asesoramiento financiero.",
    readFullDisclaimer: "Leer Descargo Completo",
    
    // Términos
    termsConditions: "Términos y Condiciones",
    termsTitle: "Términos y Condiciones – DoNotBull",
    term1: "DoNotBull proporciona perspectivas de mercado impulsadas por IA y contenido financiero educativo únicamente.",
    term2: "DoNotBull NO es un asesor financiero, corredor o gestor de activos.",
    term3: "Los usuarios utilizan la información bajo su propio riesgo.",
    term4: "Todas las suscripciones son servicios digitales.",
    term5: "Compartir el acceso a la cuenta está estrictamente prohibido.",
    term6: "DoNotBull puede actualizar, modificar o eliminar contenido en cualquier momento.",
    term7: "Al suscribirse, acepta todas las páginas que incluyen:",
    termDisclaimer: "Descargo",
    termPrivacy: "Política de Privacidad",
    termRefund: "Política de Reembolso",
    termSubscription: "Política de Suscripción",
    termResponsibility: "DoNotBull no es responsable de ninguna pérdida financiera, decisiones, errores técnicos o mal uso de la información.",
    
    // Política de Privacidad
    privacyPolicy: "Política de Privacidad",
    privacyTitle: "Política de Privacidad – DoNotBull",
    privacyCollect: "Podemos recopilar:",
    privacyName: "Nombre",
    privacyEmail: "Dirección de correo electrónico",
    privacyPayment: "Información de pago (a través de un proveedor externo seguro)",
    privacyUsage: "Datos de uso del sitio web",
    privacyUse: "Usamos estos datos para:",
    privacyAccess: "Proporcionar acceso a su suscripción",
    privacyImprove: "Mejorar nuestros servicios",
    privacySendEmails: "Enviar correos importantes relacionados con la cuenta",
    privacyNoSell: "NO vendemos sus datos personales a terceros.",
    privacyRights: "Sus derechos:",
    privacyExport: "Solicitar exportación de sus datos",
    privacyDelete: "Solicitar eliminación de sus datos",
    privacyModify: "Modificar su perfil",
    privacyContact: "Para cualquier solicitud:",
    
    // Política de Reembolso
    refundPolicy: "Política de Reembolso",
    refundTitle: "Política de Reembolso – DoNotBull",
    refundText1: "Debido a la naturaleza del contenido digital y el acceso instantáneo proporcionado en el momento de la compra, todas las ventas son finales.",
    refundNoRefunds: "No se emitirán reembolsos una vez que se haya accedido al contenido.",
    refundException: "Excepción:",
    refundBillingError: "Error de facturación comprobado dentro de las 72 horas posteriores al pago.",
    refundContactText: "Para consultas de facturación, contacte:",
    
    // Política de Suscripción
    subscriptionPolicy: "Política de Suscripción",
    subscriptionTitle: "Política de Suscripción – DoNotBull",
    subscriptionAgree: "Al suscribirse, acepta que:",
    subscriptionBilled: "Su suscripción se factura automáticamente",
    subscriptionRecurring: "La facturación es recurrente (mensual / anual)",
    subscriptionCancel: "Puede cancelar en cualquier momento",
    subscriptionNoPartial: "No se proporcionan reembolsos parciales",
    subscriptionActive: "El acceso permanece activo hasta el final del período de facturación",
    subscriptionCancelHow: "Para cancelar:",
    subscriptionCancelText: "Use su panel de control o contacte al soporte en",
    
    // Política de Cookies
    cookiePolicy: "Política de Cookies",
    cookieTitle: "Política de Cookies – DoNotBull",
    cookieUse: "Usamos cookies para:",
    cookieKeepLogged: "Mantener a los usuarios conectados",
    cookiePerformance: "Mejorar el rendimiento del sitio",
    cookieAnalyze: "Analizar el tráfico",
    cookieAccept: "Al usar este sitio web, acepta nuestro uso de cookies.",
    cookieDisable: "Puede deshabilitar las cookies en la configuración de su navegador.",
    
    // Contacto
    contactUs: "Contáctenos",
    contactTitle: "Contacto – DoNotBull",
    contactSupport: "Email de Soporte:",
    contactGeneral: "Consultas Generales:",
    contactWebsite: "Sitio Web:",
    contactCompanyInfo: "DoNotBull es una plataforma educativa independiente que proporciona perspectivas financieras impulsadas por IA.",
    contactCompanyDetails: "(Detalles de la empresa se agregarán al momento de la incorporación.)",
    contactResponse: "Típicamente respondemos dentro de 24-48 horas.",
    
    // Footer Legal
    footerLegal: "Legal",
    footerPolicies: "Políticas",
    footerContact: "Contacto",
    footerCompanyInfo: "Perspectivas financieras impulsadas por IA con fines educativos.",
    footerCopyright: "DoNotBull. Todos los derechos reservados.",
    footerDisclaimer: "NO proporcionamos servicios de inversión. NO gestionamos fondos. NO ofrecemos servicios de corretaje.",
  }
};

export const useTranslation = (lang = 'en') => {
  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  return { t };
};
